type PromiseHandlerReturn<T> = Promise<[null, T] | [Error]>

async function promiseHandler<T>(promise: Promise<T>): PromiseHandlerReturn<T> {
  try {
    const data = await promise
    return [null, data]
  } catch (error) {
    // @ts-ignore - non-trivial type error after updating TS to v4.7.4
    return [null]
  }
}

export default promiseHandler
